import dynamic from 'next/dynamic';
import { BookingAcknowledgementProps } from './BookingAcknowledgement.types';

export const BookingAcknowledgement = dynamic<BookingAcknowledgementProps>(() =>
  import('./BookingAcknowledgement').then(module => module)
);
